import styled from 'styled-components';

const activeColor = '#E3F0E8';
const inactiveColor = '#F7DEE1';

const activeTextColor = '#8ED299';
const inactiveTextColor = '#F99292';

const getBGColor = (state) => {
  return state === 'activo'
    ? activeColor
    : state === 'inactivo'
    ? inactiveColor
    : '#ccc';
};

const getTextColor = (state) => {
  return state === 'activo'
    ? activeTextColor
    : state === 'inactivo'
    ? inactiveTextColor
    : '#ccc';
};

const Pill = styled.span`
  text-transform: capitalize;
  display: flex;
  justify-content: center;
  font-size: 12px;
  border-radius: 5px;
  font-family: inherit;
  align-items: center;
  width: 60px;
  height: 15px;
  background-color: ${(props) => getBGColor(props.state)};
  color: ${(props) => getTextColor(props.state)};
`;

const ListItemContainer = styled.div`
  height: 65px;
  width: 80%;
  padding: 5px;
  margin-bottom: 10px;
  display: flex;
  flex-direction: row;
  align-items: center;

  &:hover {
    cursor: pointer;
    background-color: #f6f7f9;
  }

  @media (min-width: 685px) {
    width: 90%;
  }

  @media (min-width: 890px) {
    width: 45%;
    margin-right: auto;
  }
`;

export { Pill, ListItemContainer };
